import { Text } from './Text';

interface SegmentedControlOption<T> {
  label: string;
  value: T;
  labelColor?: string;
}

interface SegmentedControlProps<T> {
  options: SegmentedControlOption<T>[];
  selectedValue: T;
  onValueChange: (value: T) => void;
  backgroundColor?: string;
  selectedBackgroundColor?: string;
  unselectedTextColor?: string;
  selectedTextColor?: string;
}

function SegmentedControl<T>({
  options,
  selectedValue,
  onValueChange,
  backgroundColor = '#f3f4f6',
  selectedBackgroundColor = '#ffffff',
  unselectedTextColor = 'var(--text-secondary)',
  selectedTextColor = 'var(--text-primary)'
}: SegmentedControlProps<T>) {
  const selectedIndex = options.findIndex((option) => option.value === selectedValue);

  return (
    <div
      style={{
        display: 'flex',
        backgroundColor,
        borderRadius: '8px',
        position: 'relative',
        width: '100%'
      }}
    >
      {/* Selected segment background */}
      {selectedIndex >= 0 && (
        <div
          style={{
            position: 'absolute',
            top: '4px',
            left: `calc(4px + ${selectedIndex} * (100% - 8px) / ${options.length})`,
            width: `calc((100% - 8px) / ${options.length})`,
            height: 'calc(100% - 8px)',
            backgroundColor: selectedBackgroundColor,
            borderRadius: '6px',
            transition: 'all 0.2s ease',
            boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)'
          }}
        />
      )}

      {/* Segments */}
      {options.map((option, index) => {
        const isSelected = option.value === selectedValue;
        return (
          <button
            key={index}
            onClick={() => onValueChange(option.value)}
            style={{
              flex: 1,
              padding: '8px 16px',
              border: 'none',
              backgroundColor: 'transparent',
              borderRadius: '6px',
              cursor: 'pointer',
              position: 'relative',
              zIndex: 1,
              transition: 'all 0.2s ease',
              minWidth: '60px',
              outline: 'none'
            }}
          >
            <Text
              variant={isSelected ? 'body2-medium' : 'body2'}
              style={{
                color: option.labelColor ?? (isSelected ? selectedTextColor : unselectedTextColor)
              }}
            >
              {option.label}
            </Text>
          </button>
        );
      })}
    </div>
  );
}

export default SegmentedControl;
